import InspirationTokenSvg from './InspirationTokenSvg';

export default InspirationTokenSvg;
export { InspirationTokenSvg };
